import { ESSENTIAL_CARE_ROOT_PATH } from '../paths';

export const ESSENTIAL_CARE_ACTIVATION_ROOT_PATH = `${ESSENTIAL_CARE_ROOT_PATH}/activation`;
const ESSENTIAL_CARE_ELIGIBILITY_ROOT = `${ESSENTIAL_CARE_ACTIVATION_ROOT_PATH}/select-eligibility`;

export const ESSENTIAL_CARE_ACTIVATION_PATHS = {
  ACTIVATE_KIT: `${ESSENTIAL_CARE_ACTIVATION_ROOT_PATH}/activate-kit`,
  ALREADY_ACTIVATED: `${ESSENTIAL_CARE_ACTIVATION_ROOT_PATH}/already-activated`,
  CONFIRMATION: `${ESSENTIAL_CARE_ACTIVATION_ROOT_PATH}/confirmation`,
  CONTACT_SUPPORT: `${ESSENTIAL_CARE_ACTIVATION_ROOT_PATH}/contact-support`,
  IN_PERSON_CARE: `${ESSENTIAL_CARE_ACTIVATION_ROOT_PATH}/in-person-care`,
  START: `${ESSENTIAL_CARE_ACTIVATION_ROOT_PATH}/start`,
};

export const ESSENTIAL_CARE_ACTIVATION_ELIGIBILITY_PATHS = {
  // Page to look up a population by organization or program code (determined by flag
  // essential-care-program-code-population-selection-january-2023) before confirming eligibility
  FIND_POPULATION: `${ESSENTIAL_CARE_ELIGIBILITY_ROOT}/eligibility`,
  // Page to pick a population from all the ones eligibility has already been confirmed for
  SELECT_POPULATION: `${ESSENTIAL_CARE_ELIGIBILITY_ROOT}/program`,
  // Page to enter an eligibility identifier (can be a Unique ID, Email, or Demographic Factors)
  ENTER_IDENTIFIER: `${ESSENTIAL_CARE_ELIGIBILITY_ROOT}/identifier`,
  // Page instructing user to confirm their email address. Note that this doesn't actually work for
  // Essential Care yet (EC-1446).
  CONFIRM_EMAIL_ADDRESS: (email: string = ':email') =>
    `${ESSENTIAL_CARE_ELIGIBILITY_ROOT}/confirmation/${email}`,
};
